import { getUnitPoints } from "../../utils/points";
import { getUnitName } from "../../utils/unit";

const LIST_CATEGORIES = [
  "characters",
  "lords",
  "heroes",
  "core",
  "special",
  "rare",
  "mercenaries",
  "allies",
];

const hasActiveCommand = (unit, commandName) =>
  Boolean(
    unit?.command?.length &&
      unit.command.find(
        (command) => command.name_en === commandName && command.active,
      ),
  );

// Flatten an OWB list into the shape battle mode tracks.
export const getTrackableUnits = ({ list, language }) => {
  if (!list) return [];

  const armyComposition = list.armyComposition || list.army;
  const units = [];

  LIST_CATEGORIES.forEach((type) => {
    (list[type] || []).forEach((unit) => {
      units.push({
        id: unit.id,
        name: getUnitName({ unit, language }),
        points: getUnitPoints({ ...unit, type }, { armyComposition }),
        strength: unit.strength || unit.minimum || 1,
        isGeneral: hasActiveCommand(unit, "General"),
        isBSB: hasActiveCommand(unit, "Battle Standard Bearer"),
      });
    });
  });

  return units;
};

// Parse manually entered opponent units, one per line:
//   "Chosen Knights - 320"  /  "Chosen Knights, 320"  /  "Chosen Knights 320"
export const parseOpponentUnits = (text) => {
  return text
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line, index) => {
      const match = line.match(/^(.*?)[\s,–-]+(\d+)\s*(?:pts?)?\.?$/i);

      if (match) {
        return {
          id: `opponent-${index}`,
          name: match[1].trim().replace(/[,–-]+$/, "").trim(),
          points: Number(match[2]),
          strength: 1,
        };
      }
      return { id: `opponent-${index}`, name: line, points: 0, strength: 1 };
    });
};
